import React, { useContext, useEffect,useState, useReducer, useRef } from "react";
import { MenuActive } from "../context/MenuActiveContext";
import {  FaImage, FaMagnifyingGlass } from "react-icons/fa6";
import { IoMdSend } from "react-icons/io";
import Echo from 'laravel-echo';
import axios from 'axios';
import Pusher from 'pusher-js';
import { getTokenSession } from '../utils/common';
import { MyContext } from "../context/MyContext";
import Loader from "../components/Loader";
import useFetch from "../customHooks/useFetch";
import config from "../services/config.json";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import userImage from "../dist/webImages/dummy-profile-1.jpg";

const initialState = {
    galleryActive: false,
    updateImage: {
        image: "",
        message: "",
        value: ""
    },
    data: {
        activelist: [],
        activeChat:{},
        chatdata: [
            ]
    }
};  

function reducer(state, action) {
    switch (action.type) {
        case "SET_GALLERY_ACTIVE":
            return { ...state, galleryActive: action.payload };
        case "SET_UPDATE_IMAGE":
            return { ...state, updateImage: action.payload };
        case "SET_ACTIVE_DATA":
            return {  ...state,   data: {  ...state.data,  activelist: action.payload} }
        case "SET_ACTIVE_CHAT_DATA":
            return {  ...state,   data: {  ...state.data,  activeChat: action.payload} }
        case "SET_CHAT_ALL_DATA":
            return {  ...state,   data: {  ...state.data,  chatdata: action.payload} }
            case "SET_CHAT_DATA":
                const { date, ...newChatData } = action.payload;
            // Find the index of the date in the chat data
            const dateIndex = state.data.chatdata.findIndex(chat => chat.date === date);
            if (dateIndex !== -1) {
                const updatedChatData = [...state.data.chatdata];
                updatedChatData[dateIndex] = {
                    ...updatedChatData[dateIndex],
                    chat_data: [...updatedChatData[dateIndex].chat_data, newChatData]
                };
                return {
                    ...state,
                    data: {
                        ...state.data,
                        chatdata: updatedChatData
                    }
                };
            }

            // If date doesn't exist, add new date and chat data
            return {
                ...state,
                data: {
                    ...state.data,
                    chatdata: [
                        ...state.data.chatdata,
                        {
                            date: date,
                            chat_data: [newChatData]
                        }
                    ]
                }
            };
        default:
            return state;
    }
}

const Discussions = () => {
    const [loading, setLoading] = useState(true);
    const [loading3, setLoading3] = useState(false);
    const [filterList, setFilterList] = useState([]);
    const { rolesData } = useContext(MyContext);
    const { loading2, data: chatlist,error } = useFetch(`chat/userChatList/${rolesData.shop_id}`);
    const { setMunuActiv } = useContext(MenuActive);
    const [state, dispatch] = useReducer(reducer, initialState);
    const chatContainerRef = useRef(null);
    const fileInputRef = useRef(null);
    const isComponentMounted = useRef(true);
    const [onlineUsers, setOnlineUsers] = useState([]);
    const inputRef = useRef(null); // Reference for the input field
  const [errorShow, setErrorShow] = useState(false)  
  const [statusUpdate, setStatusUpdate] = useState(null)  
  const [statusUpdate2, setStatusUpdate2] = useState({})  
    axios.defaults.headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getTokenSession()}`,
    };




    useEffect(() => {
        if (isComponentMounted.current) {
            axios.post(`${config.apiEndPoint}chat/updateStatus`,{
                "id":rolesData.shop_id  ,
                "user_type":"vendor",
                "status":1
            })
            .then((response) => {
                setStatusUpdate(response.data)
            })
            .catch((error) => {
              if (error.response.status === 401) toast.error(error.response.data.message);
              else toast.error(error.response.data.errorMessage);
            });
          }
          return () => {
            isComponentMounted.current = false;
            axios.post(`${config.apiEndPoint}chat/updateStatus`,{
              "id":rolesData.shop_id  ,
              "user_type":"vendor",
              "status":0
          })
          .then((response) => {
              setStatusUpdate(response.data)
          })
          .catch((error) => {
            if (error.response.status === 401) toast.error(error.response.data.message);
            else toast.error(error.response.data.errorMessage);
          });
            
          };

    }, [])
    const { galleryActive, updateImage, data } = state;
    const { activelist, activeChat, chatdata } = data;
  
    useEffect(() => {
      setMunuActiv([true, "discussions"]);
    }, [setMunuActiv]);
  
    useEffect(() => {
      if (chatContainerRef.current) {
        chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
      }
    }, [chatdata]);


    useEffect(() => {
        const handleKeyDown = (event) => {
            if (inputRef.current) {
                inputRef.current.focus(); // Focus the input field whenever it changes
            }
            if (event.key === 'Enter') {
                sendMessage();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [updateImage.message,]);

    useEffect(() => { 
      if (chatlist) {
        setLoading(false);
      }
      if (chatlist && chatlist.data.length > 0) {
        let dataa = chatlist.data;
        let a = statusUpdate2
        for (let index = 0; index < dataa.length; index++) {
            a[dataa[index].sender_id] = dataa[index].user_status
        }
        console.log(a)
        setStatusUpdate2(a)
        dispatch({
          type: "SET_ACTIVE_DATA",
          payload: dataa,
        });
        setFilterList(dataa)

      }
    }, [chatlist]);
  
    useEffect(() => {
        const echo = new Echo({
            broadcaster: 'pusher',
            key: '18e48a20e5b3b8af7894',
            cluster: 'ap2',
            encrypted: true,
            authEndpoint: `${config.apiEndPoint}chat/broadcasting/auth`, // Ensure correct endpoint path
            auth: {
                headers: {
                    Authorization: `Bearer ${getTokenSession()}`,
                },
            },
        });
        
        // Handle Pusher connection errors
        echo.connector.pusher.connection.bind('error', function (err) {
            console.log('Pusher error:', err);
        });
        
        // Join the chatroom channel
        const channel = echo.join('chatroom');
        // Handle presence channel events
        channel.here((users) => {
            let userss = []
            for (let index = 0; index < users.length; index++) {
                userss.push(users[index].id)
            }
            setOnlineUsers(userss);
            console.log('Here:', users);
        });
        
        channel.joining((user) => {
            setOnlineUsers((prevUsers) => [...prevUsers, user.id]);
            console.log('User joining:', user);
        });
        
        channel.leaving((user) => {
            let userss = []
            for (let index = 0; index < user.length; index++) {
                userss.push(user[index].id)
            }
            setOnlineUsers((prevUsers) => prevUsers.filter((u) => u !== user.id));
            console.log('User leaving:', user);
        });
    
        // Clean up: leave the channel when component unmounts
        return () => {
          echo.leave('chatroom');
        };
      }, []);
      
      
      
  
    useEffect(() => {
      if (activeChat) {
        const pusher = new Pusher('18e48a20e5b3b8af7894', {
          cluster: 'ap2',
          encrypted: true,
        });
  
        const channel = pusher.subscribe(`chat_user${activeChat.sender_id}_shop${rolesData.shop_id}`);
        pusher.connection.bind('connected', () => {
          console.log('Pusher connected');
          console.log('Subscribed to channel: ' + channel.name);
        });
  
        pusher.connection.bind('disconnected', () => {
          console.log('Pusher disconnected');
        });
  
        pusher.connection.bind('connecting', () => {
          console.log('Pusher connecting');
        });
  
        pusher.connection.bind('state_change', (states) => {
          console.log('Pusher state changed', states);
        });
  
        pusher.connection.bind('error', (err) => {
          console.error('Pusher error', err);
        });
  
        channel.bind('chat', (data) => {
          const { id, messages, message_sender_id } = data.message;
          const currentTime = new Date().toISOString().split('T')[0];
          if(rolesData.id !== message_sender_id) {
              dispatch({
                  type: "SET_CHAT_DATA",
                  payload: {
                      id: id,
                      key: new Date().getUTCMilliseconds(),
                      image: updateImage.image,
                      messages: messages,
                      message_sender_id: message_sender_id ?? rolesData.id,
                      sender_id: activeChat.sender_id,
                      receiver_id: rolesData.shop_id,
                      date: currentTime,
                    },
                });
            }
        });
  
        return () => {
          channel.unbind_all();
          channel.unsubscribe();
        };
      }
    }, [activeChat,statusUpdate, rolesData.shop_id]);


      useEffect(() => {
        if (activeChat) {
          const pusher2 = new Pusher('18e48a20e5b3b8af7894', {
            cluster: 'ap2',
            encrypted: true,
          });
    
          const channel2 = pusher2.subscribe(`user_sidebar_list`);
          pusher2.connection.bind('connected', () => {
            console.log('Pusher connected2');
            console.log('Subscribed to channel2: ' + channel2.name);
          });
    
          pusher2.connection.bind('disconnected', () => {
            console.log('Pusher disconnected2');
          });
    
          pusher2.connection.bind('connecting', () => {
            console.log('Pusher connecting2');
          });
    
          pusher2.connection.bind('state_change', (states) => {
            console.log('Pusher state changed2', states);
          });
    
          pusher2.connection.bind('error', (err) => {
            console.error('Pusher error2  ', err);
          });
    
          channel2.bind('sidebar_list', (data) => {
            console.log(data,rolesData)
            if(data.userListData?.vendor_list?.list_user_id == rolesData?.shop_id) {
              if(data.userListData?.user_status) {
                let a = statusUpdate2
               a[data.userListData?.user_id] = data.userListData?.user_id
                setStatusUpdate2(a)
            }
            else if(data.userListData?.vendor_status) {

            }
            else {
                const {list} = data.userListData.vendor_list;
                const activeIndex = list.findIndex((item) => item.sender_id === activeChat.sender_id)
                if(list[0].message_sender_id === rolesData.id) {
                    let filterlistdata = list
                    filterlistdata[activeIndex].unread_chat_count = 0
                    setFilterList(filterlistdata)
        }
        else {
          if(activeChat.sender_id === undefined) {
            setFilterList(list)
          }
          else {
            axios.post(`${config.apiEndPoint}chat/updateMessageStatus`,{
              "id": activeChat.sender_id,
              "user_type": "vendor",
              "sender_id": activeChat.sender_id,
              "receiver_id": activeChat.receiver_id,
              "message_sender_id": activeChat.sender_id,
            })
                .then((response) => {
                  let filterlistdata = list
                  filterlistdata[activeIndex].unread_chat_count = 0
                  setFilterList(filterlistdata)
                })
                .catch((error) => {
                  if (error.response.status === 401) toast.error(error.response.data.message);
                  else toast.error(error.response.data.errorMessage);
                });
              }
            }
            }
                
            }
          

    
          });
    
          return () => {
            channel2.unbind_all();
            channel2.unsubscribe();
          };
        }
      }, [activeChat, rolesData.shop_id]);
  
    const handleActive = (item,index) => {
      dispatch({ type: "SET_ACTIVE_CHAT_DATA", payload: item });
      let filterlistdata = filterList
      filterlistdata[index].unread_chat_count = 0
      setFilterList(filterlistdata)
      axios.post(`${config.apiEndPoint}chat/updateMessageStatus`,{
        "id": item.sender_id,
        "user_type": "vendor",
        "sender_id": item.sender_id,
        "receiver_id": item.receiver_id,
        "message_sender_id": item.sender_id,
      })
        .then((response) => {
          axios.get(`${config.apiEndPoint}chat/getUserChat/${item.sender_id}/${rolesData.shop_id}`)
          .then((response) => {
            setLoading(false);
            dispatch({
              type: "SET_CHAT_ALL_DATA",
              payload: response.data.data,
            });
          })
          .catch((error) => {
            if (error.response === undefined) {
                setErrorShow(true)
                console.log('No response received. Likely internet connection issue.');
                // Handle internet connection issue here
              }
            if (error.response.status === 401) toast.error(error.response.data.message);
            else toast.error(error.response.data.errorMessage);
          });
        })
        .catch((error) => {
            if (error?.response === undefined) {
                setErrorShow(true)
              }
          if (error.response.status === 401) toast.error(error.response.data.message);
          else toast.error(error.response.data.errorMessage);
        });
    };
  
    const sendMessage = () => {
        const currentTime = new Date().toISOString().split('T')[0];
      if (updateImage.message) {
        dispatch({
            type: "SET_CHAT_DATA",
            payload: {
                id:rolesData.id,
                image: updateImage.image,
                messages: updateImage.message,
                message_sender_id:  rolesData.id,
                sender_id: activeChat.sender_id,
                receiver_id: rolesData.shop_id,
                date: currentTime,
              },
          });
        setLoading3(true);
        dispatch({
          type: "SET_UPDATE_IMAGE",
          payload: {
            image: "",
            message: "",
            value: "",
          },
        });
        axios.defaults.headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getTokenSession()}`,
        };
        axios
          .post(
            `${config.apiEndPoint}chat/sendMessage`,
            {
              message_sender_id: rolesData.id,
              sender_id: activeChat.sender_id,
              receiver_id: rolesData.shop_id,
              message: updateImage.message,
              user_type: "vendor",
            },  
            {
              headers: {
                'X-Socket-Id': Pusher.instances[0].connection.socket_id,
              },
            }
          )
          .then(() => {
            setLoading3(false);
          })
          .catch((error) => {
            if (error.response === undefined) {
                setErrorShow(true)
                // console.log('No response received. Likely internet connection issue.');
                // Handle internet connection issue here
              }
            console.error('Error sending message:', error);
          });
      }
    };
  
    const handleInput = (e) => {
      setFilterList(activelist.filter((item) => item.name.toLowerCase().includes(e.toLowerCase())));
    };
  
    const handleFileChange = (e) => {
      const selectedFile = e.target.files[0];
      if (selectedFile) {
        const path = (window.URL || window.webkitURL).createObjectURL(selectedFile);
        dispatch({
          type: "SET_UPDATE_IMAGE",
          payload: {
            image: path,
            label: "",
            value: selectedFile,
          },
        });
        dispatch({ type: "SET_GALLERY_ACTIVE", payload: true });
      }
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    };
  
    const handleImageClose = () => {
      dispatch({
        type: "SET_UPDATE_IMAGE",
        payload: {
          image: "",
          label: "",
          value: "",
        },
      });
      dispatch({ type: "SET_GALLERY_ACTIVE", payload: false });
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    };

if(loading || loading2) return <Loader />;

    return (
        <div className="Discussions">
            <style>{`
                .dashboard__Body {
                    padding: 0;
                }
            `}</style>
            <div className="Discussions_ grid grid-cols-[3fr,7fr]">
                <div className="Discussions_left min-h-screen bg-white py-4 px-3">
                    <h2 className="text-[1.5rem] font-medium mb-4">Discussions</h2>
                    <div className="relative">
                        <input  type="text"  className="border border[#ddd] rounded-full w-full py-2 pl-10 outline-none" onInput={(e) => handleInput(e.target.value)}  /> <FaMagnifyingGlass className="absolute left-4 top-[50%] transform translate-y-[-50%]" />
                    </div>
                    <div className="Discussions_list mt-4">
                        <ul className="list">
                            {filterList.map((item,index) => {
                                const { id, profile_image, messages,name, last_message_at,sender_id,unread_chat_count  } = item;
                                let mestrue = false
                                let chats = {}
                                let aa =  messages.split("\n")
                                if(item.messages.includes("\n")) {
                                    mestrue = true;
                                    chats = {
                                        "product_image":aa[0],
                                        "product_name":aa[1],
                                        "product_price":aa[2]
                                    }
                                }
                                return (
                                    <li key={index} className={`grid Discussions_listl relative items-center  grid-cols-[auto,1fr] gap-3 mb-3 cursor-pointer ${activeChat.sender_id === sender_id ? "active" : ""}`} onClick={() => handleActive(item,index)}>
                                        <div className={`Discussions_listlll rounded-full relative  ${statusUpdate2[sender_id] === 1 ? "border-2 border-[green]" : ""}  `}>
                                            <img
                                                className="w-full h-full rounded-full"
                                                src={profile_image}
                                                alt="images.jpg"
                                                onError={(e)=> e.target.src = userImage}
                                            />
                                        {/* <span className="absolute bottom-0 right-[.5rem] w-2 h-2 rounded-full bg-green-700"></span> */}
                                        </div>
                                        <div>
                                            <div className="h2">{name}</div>
                                            <ul className="list">
                                                <li className="flex justify-between text-[#837878]">
                                                    <div className="text-[.7rem] leading-[.8rem]">{mestrue ? <div className="text-[#8696a0] flex gap-1"> <FaImage /> <span>Product</span></div> : messages}</div>
                                                    <div className="text-[.7rem] leading-[.8rem]">{last_message_at}</div>
                                                </li>
                                            </ul>
                                        </div>
                                        {unread_chat_count !== 0 && <span className="absolute top-2 right-3 bg-[#ed2656] w-5 h-5 grid place-items-center text-white rounded-full">{unread_chat_count}</span>}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
                <div className="Discussions_right">
                    {activeChat.name ? <>
                        <div className="Discussions_right-top flex gap-2 items-center bg-white py-3 px-4 border-b border-[#ddd]">
                        <button className="lg:hidden block bg-[#ed2656] text-white px-2 py-2 rounded-lg">Back</button>
                        <div className="grid items-center grid-cols-[auto,1fr] gap-2">
                            <div className="w-10 h-10">
                                <img
                                    className="w-full h-full rounded-full"
                                    src={activeChat?.profile_image}
                                    onError={(e)=> e.target.src = userImage}
                                    alt="images.jpg"
                                />
                            </div>
                            <div>
                                <div className="h2">{activeChat?.name}</div>
                                {/* <div className="text-[.7rem] leading-[.8rem] capitalize">{statusUpdate2[activeChat.sender_id] === 1 ? "Online" : "Offline"}</div> */}
                            </div>
                        </div>
                    </div>
                    <div className="Discussions_right- relative">
                    <div ref={chatContainerRef} className="Discussions_right-center h-[calc(100vh-130px)] overflow-y-auto p-4 scroll-smooth">
                        <div className="chat">
                         {(chatdata).map((ite,index) => { 
    return (
        <div key={index}>
            <div className="text-center bg-gray-300 w-fit p-2 rounded-md mx-auto">{ite.date}</div>
            {ite.chat_data.map((item, index2) => {
                 let mestrue = false
                 let chats = {}
                 let aa =  item?.messages?.split("\n") ?? ""
                 if(item?.messages?.includes("\n")) {
                     mestrue = true;
                     chats = {
                         "product_image":aa[0],
                         "product_name":aa[1],
                         "product_price":aa[2]
                     }
                 }
                return (
                     <div key={index2} className={`${item?.message_sender_id !== rolesData?.id ? "" : "rightSide ml-auto"} w-fit`} style={{ maxWidth: "50%" }}>
                                 <div className={`my-3 ${item?.message_sender_id === rolesData?.id ? "bg-[#ddd]" : "bg-[#ed2656]"} p-3 rounded-2xl`}>
                                 {mestrue ? (
  <>
     <img className="w-full rounded-3xl mb-2" src={chats?.product_image} alt="11" />
    <div className={`h4 ${item?.message_sender_id === rolesData?.id ? "" : "text-white"}`}> {chats?.product_name} </div>
    {/* {item?.rating && <Rate disabled allowHalf defaultValue={item?.rating} />} */}
 
      <div className={`h4 ${item?.message_sender_id === rolesData?.id ? "" : "text-white"}`}>{chats?.product_price}</div>

  </>
) : (
  <div className={`h4 ${item?.message_sender_id === rolesData?.id ? "" : "text-white"}`}>
    {item?.messages}
  </div>
)}

                                 </div>
                                 <div className={`flex items-center -mt-[.7rem] gap-2 ${item?.message_sender_id !== rolesData?.id ? "text-left justify-start" : "text-right justify-end"} `}>
                                 <span className={`text-[#5f5f5f] text-[12px]  block `}>{dayjs(item?.created_at).format('HH:mm')}</span>

                                 {/* {item?.message_sender_id === rolesData?.id && <svg viewBox="0 0 16 11" height="11" width="16" preserveAspectRatio="xMidYMid meet" className="" fill="none"><title>msg-dblcheck</title><path d="M11.0714 0.652832C10.991 0.585124 10.8894 0.55127 10.7667 0.55127C10.6186 0.55127 10.4916 0.610514 10.3858 0.729004L4.19688 8.36523L1.79112 6.09277C1.7488 6.04622 1.69802 6.01025 1.63877 5.98486C1.57953 5.95947 1.51817 5.94678 1.45469 5.94678C1.32351 5.94678 1.20925 5.99544 1.11192 6.09277L0.800883 6.40381C0.707784 6.49268 0.661235 6.60482 0.661235 6.74023C0.661235 6.87565 0.707784 6.98991 0.800883 7.08301L3.79698 10.0791C3.94509 10.2145 4.11224 10.2822 4.29844 10.2822C4.40424 10.2822 4.5058 10.259 4.60313 10.2124C4.70046 10.1659 4.78086 10.1003 4.84434 10.0156L11.4903 1.59863C11.5623 1.5013 11.5982 1.40186 11.5982 1.30029C11.5982 1.14372 11.5348 1.01888 11.4078 0.925781L11.0714 0.652832ZM8.6212 8.32715C8.43077 8.20866 8.2488 8.09017 8.0753 7.97168C7.99489 7.89128 7.8891 7.85107 7.75791 7.85107C7.6098 7.85107 7.4892 7.90397 7.3961 8.00977L7.10411 8.33984C7.01947 8.43717 6.97715 8.54508 6.97715 8.66357C6.97715 8.79476 7.0237 8.90902 7.1168 9.00635L8.1959 10.0791C8.33132 10.2145 8.49636 10.2822 8.69102 10.2822C8.79681 10.2822 8.89838 10.259 8.99571 10.2124C9.09304 10.1659 9.17556 10.1003 9.24327 10.0156L15.8639 1.62402C15.9358 1.53939 15.9718 1.43994 15.9718 1.32568C15.9718 1.1818 15.9125 1.05697 15.794 0.951172L15.4386 0.678223C15.3582 0.610514 15.2587 0.57666 15.1402 0.57666C14.9964 0.57666 14.8715 0.635905 14.7657 0.754395L8.6212 8.32715Z" fill={`${item.message_type === "read" ? "#53bdeb": "#252525"}`}></path></svg>} */}
                                 </div>
                                
                             </div>
                );
            })}
        </div>
    );
})}
                        </div>
                    </div>
                            
                    <div className="Discussions_right-bottom border-t border-[#ddd] bg-white py-3 px-5">
                        <div className="grid grid-cols-[1fr,auto] items-center gap-4">
                            <input
                            ref={fileInputRef}
                                onChange={handleFileChange}
                                type="file"
                                name="gallery"
                                id="gallery"
                                className="cursor-pointer w-0 h-0 opacity-0 absolute"
                            />
                            {/* <label htmlFor="gallery" className="cursor-pointer">
                                <GrGallery className="text-[#ed2656] text-[1.3rem]" />
                            </label> */}
                            <div className="w-full">
                                <input
                                    type="text"
                                    className="border border[#ddd] rounded-full w-full py-2 px-4 outline-none"
                                    placeholder="Start a new Message"
                                    value={updateImage?.message ?? ""}
                                    onChange={(e) => dispatch({ type: "SET_UPDATE_IMAGE", payload: { ...updateImage, message: e.target.value } })}
                                    ref={inputRef}
                                />
                            </div>
                            <button  onClick={sendMessage} disabled={loading3} className={`w-10 dsdsds h-10 bg-[#ed2656] rounded-full grid place-items-center ${loading3 ? `cursor-progress` : `cursor-pointer`}`}> 
                              
<IoMdSend className="text-[#fff] text-[1.3rem]" />
                                
                    
                            </button>
                        </div>
                    </div>
                    {galleryActive && (
                        <div className="chat2 absolute w-full h-full left-0 top-0 bg-white border border-[#ddd] border-t-0">
                            <div className="chat2_top p-4 cursor-pointer">
                                <svg
                                    onClick={handleImageClose}
                                    viewBox="0 0 24 24"
                                    height="24"
                                    width="24"
                                    preserveAspectRatio="xMidYMid meet"
                                    className=""
                                    fill="currentColor"
                                    enableBackground="new 0 0 24 24"
                                >
                                    <title>x</title>
                                    <path d="M19.6004 17.2L14.3004 11.9L19.6004 6.60005L17.8004 4.80005L12.5004 10.2L7.20039 4.90005L5.40039 6.60005L10.7004 11.9L5.40039 17.2L7.20039 19L12.5004 13.7L17.8004 19L19.6004 17.2Z"></path>
                                </svg>
                            </div>
                            <div className="chat2_bottom mt-14 text-center w-[80%] mx-auto">
                                {updateImage && <img src={updateImage.image} className="w-100 max-h-[15rem] object-cover" alt="" />}
                                <input
                                    type="text"
                                    value={updateImage.message}
                                    onChange={(e) => dispatch({ type: "SET_UPDATE_IMAGE", payload: { ...updateImage, message: e.target.value } })}
                                    className="mt-5 border border-[#ddd] w-full rounded-lg py-3 px-4 outline-none placeholder:[#ddd]"
                                    placeholder="Add a caption"
                                />
                            </div>
                            {/* <div className="chatFooter flex justify-end p-5">
                            <div  onClick={handleSubmit} className="w-10 h-10 bg-[#ed2656] rounded-full grid place-items-center cursor-pointer">
                                <IoMdSend className="text-[#fff] ddd text-[1.3rem]" />
                            </div>
                            </div> */}
                        </div>
                    )}
                    </div>
                    </> : 
                    
                    <div className="p-4 grid h-svh place-items-center">
                        <svg viewBox="0 0 303 172" width="360" preserveAspectRatio="xMidYMid meet" className="" fill="none"><title>intro-md-beta-logo-dark</title><path fillRule="evenodd" clipRule="evenodd" d="M229.565 160.229C262.212 149.245 286.931 118.241 283.39 73.4194C278.009 5.31929 212.365 -11.5738 171.472 8.48673C115.998 35.6999 108.972 40.1612 69.2388 40.1612C39.645 40.1612 9.51317 54.4147 5.74669 92.952C3.01662 120.885 13.9985 145.267 54.6373 157.716C128.599 180.373 198.017 170.844 229.565 160.229Z" fill="#364147"></path><path fillRule="evenodd" clipRule="evenodd" d="M131.589 68.9422C131.593 68.9422 131.596 68.9422 131.599 68.9422C137.86 68.9422 142.935 63.6787 142.935 57.1859C142.935 50.6931 137.86 45.4297 131.599 45.4297C126.518 45.4297 122.218 48.8958 120.777 53.6723C120.022 53.4096 119.213 53.2672 118.373 53.2672C114.199 53.2672 110.815 56.7762 110.815 61.1047C110.815 65.4332 114.199 68.9422 118.373 68.9422C118.377 68.9422 118.381 68.9422 118.386 68.9422H131.589Z" fill="#F1F1F2" fillOpacity="0.38"></path><path fillRule="evenodd" clipRule="evenodd" d="M105.682 128.716C109.186 128.716 112.026 125.908 112.026 122.446C112.026 118.983 109.186 116.176 105.682 116.176C104.526 116.176 103.442 116.481 102.509 117.015L102.509 116.959C102.509 110.467 97.1831 105.203 90.6129 105.203C85.3224 105.203 80.8385 108.616 79.2925 113.335C78.6052 113.143 77.88 113.041 77.1304 113.041C72.7503 113.041 69.1995 116.55 69.1995 120.878C69.1995 125.207 72.7503 128.716 77.1304 128.716C77.1341 128.716 77.1379 128.716 77.1416 128.716H105.682L105.682 128.716Z" fill="#F1F1F2" fillOpacity="0.38"></path><rect x="0.445307" y="0.549558" width="50.5797" height="100.068" rx="7.5" transform="matrix(0.994522 0.104528 -0.103907 0.994587 10.5547 41.6171)" fill="#ed2656" stroke="#316474"></rect><rect x="0.445307" y="0.549558" width="50.4027" height="99.7216" rx="7.5" transform="matrix(0.994522 0.104528 -0.103907 0.994587 10.9258 37.9564)" fill="#EEFAF6" stroke="#316474"></rect><path d="M57.1609 51.7354L48.5917 133.759C48.2761 136.78 45.5713 138.972 42.5503 138.654L9.58089 135.189C6.55997 134.871 4.36688 132.165 4.68251 129.144L13.2517 47.1204C13.5674 44.0992 16.2722 41.9075 19.2931 42.2251L24.5519 42.7778L47.0037 45.1376L52.2625 45.6903C55.2835 46.0078 57.4765 48.7143 57.1609 51.7354Z" fill="#DFF3ED" stroke="#316474"></path><path d="M26.2009 102.937C27.0633 103.019 27.9323 103.119 28.8023 103.21C29.0402 101.032 29.2706 98.8437 29.4916 96.6638L26.8817 96.39C26.6438 98.5681 26.4049 100.755 26.2009 102.937ZM23.4704 93.3294L25.7392 91.4955L27.5774 93.7603L28.7118 92.8434L26.8736 90.5775L29.1434 88.7438L28.2248 87.6114L25.955 89.4452L24.1179 87.1806L22.9824 88.0974L24.8207 90.3621L22.5508 92.197L23.4704 93.3294ZM22.6545 98.6148C22.5261 99.9153 22.3893 101.215 22.244 102.514C23.1206 102.623 23.9924 102.697 24.8699 102.798C25.0164 101.488 25.1451 100.184 25.2831 98.8734C24.4047 98.7813 23.5298 98.6551 22.6545 98.6148ZM39.502 89.7779C38.9965 94.579 38.4833 99.3707 37.9862 104.174C38.8656 104.257 39.7337 104.366 40.614 104.441C41.1101 99.6473 41.6138 94.8633 42.1271 90.0705C41.2625 89.9282 40.3796 89.8786 39.502 89.7779ZM35.2378 92.4459C34.8492 96.2179 34.4351 99.9873 34.0551 103.76C34.925 103.851 35.7959 103.934 36.6564 104.033C37.1028 100.121 37.482 96.1922 37.9113 92.2783C37.0562 92.1284 36.18 92.0966 35.3221 91.9722C35.2812 92.1276 35.253 92.286 35.2378 92.4459ZM31.1061 94.1821C31.0635 94.341 31.0456 94.511 31.0286 94.6726C30.7324 97.5678 30.4115 100.452 30.1238 103.348L32.7336 103.622C32.8582 102.602 32.9479 101.587 33.0639 100.567C33.2611 98.5305 33.5188 96.4921 33.6905 94.4522C32.8281 94.3712 31.9666 94.2811 31.1061 94.1821Z" fill="#316474"></path><path d="M17.892 48.4889C17.7988 49.3842 18.4576 50.1945 19.3597 50.2923C20.2665 50.3906 21.0855 49.7332 21.1792 48.8333C21.2724 47.938 20.6136 47.1277 19.7115 47.0299C18.8047 46.9316 17.9857 47.5889 17.892 48.4889Z" fill="white" stroke="#316474"></path><path d="M231.807 136.678L197.944 139.04C197.65 139.06 197.404 139.02 197.249 138.96C197.208 138.945 197.179 138.93 197.16 138.918L196.456 128.876C196.474 128.862 196.5 128.843 196.538 128.822C196.683 128.741 196.921 128.668 197.215 128.647L231.078 126.285C231.372 126.265 231.618 126.305 231.773 126.365C231.814 126.381 231.842 126.395 231.861 126.407L232.566 136.449C232.548 136.463 232.522 136.482 232.484 136.503C232.339 136.584 232.101 136.658 231.807 136.678Z" fill="white" stroke="#316474"></path><path d="M283.734 125.679L144.864 135.363C141.994 135.563 139.493 133.4 139.293 130.54L133.059 41.6349C132.858 38.7751 135.031 36.2858 137.903 36.0856L276.773 26.4008C279.647 26.2005 282.144 28.364 282.345 31.2238L288.578 120.129C288.779 122.989 286.607 125.478 283.734 125.679Z" fill="#EEFAF6"></path><path d="M144.864 135.363C141.994 135.563 139.493 133.4 139.293 130.54L133.059 41.6349C132.858 38.7751 135.031 36.2858 137.903 36.0856L276.773 26.4008C279.647 26.2004 282.144 28.364 282.345 31.2238L288.578 120.129C288.779 122.989 286.607 125.478 283.734 125.679" stroke="#316474"></path><path d="M278.565 121.405L148.68 130.463C146.256 130.632 144.174 128.861 144.012 126.55L138.343 45.695C138.181 43.3846 139.994 41.3414 142.419 41.1723L272.304 32.1142C274.731 31.945 276.81 33.7166 276.972 36.0271L282.641 116.882C282.803 119.193 280.992 121.236 278.565 121.405Z" fill="#DFF3ED" stroke="#316474"></path><path d="M230.198 129.97L298.691 125.193L299.111 131.189C299.166 131.97 299.013 132.667 298.748 133.161C298.478 133.661 298.137 133.887 297.825 133.909L132.794 145.418C132.482 145.44 132.113 145.263 131.777 144.805C131.445 144.353 131.196 143.684 131.141 142.903L130.721 136.907L199.215 132.131C199.476 132.921 199.867 133.614 200.357 134.129C200.929 134.729 201.665 135.115 202.482 135.058L227.371 133.322C228.188 133.265 228.862 132.782 229.345 132.108C229.758 131.531 230.05 130.79 230.198 129.97Z" fill="#ed2656" stroke="#316474"></path><path d="M230.367 129.051L300.275 124.175L300.533 127.851C300.591 128.681 299.964 129.403 299.13 129.461L130.858 141.196C130.025 141.254 129.303 140.627 129.245 139.797L128.987 136.121L198.896 131.245C199.485 132.391 200.709 133.147 202.084 133.051L227.462 131.281C228.836 131.185 229.943 130.268 230.367 129.051Z" fill="#EEFAF6" stroke="#316474"></path><ellipse rx="15.9969" ry="15.9971" transform="matrix(0.997577 -0.0695704 0.0699429 0.997551 210.659 83.553)" fill="#ed2656" stroke="#316474"></ellipse><path d="M208.184 87.1094L204.777 84.3593C204.777 84.359 204.776 84.3587 204.776 84.3583C203.957 83.6906 202.744 83.8012 202.061 84.6073C201.374 85.4191 201.486 86.6265 202.31 87.2997L202.312 87.3011L207.389 91.4116C207.389 91.4119 207.389 91.4121 207.389 91.4124C208.278 92.1372 209.611 91.9373 210.242 90.9795L218.283 78.77C218.868 77.8813 218.608 76.6968 217.71 76.127C216.817 75.5606 215.624 75.8109 215.043 76.6939L208.184 87.1094Z" fill="white" stroke="#316474"></path></svg>
                    </div>
                    
                    
                    }
                  
                   
                </div>
            </div>
        </div>
    );
};

export default Discussions;